import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AppCard from "@/components/public/AppCard";
export default {
  name: "HomeServe",
  components: {
    AppCard: AppCard
  },
  props: ["tourist-active"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      tabIndex: 0,
      list: []
    };
  },
  computed: {
    url: function url() {
      switch (this.tabIndex) {
        case 0:
          return "/hallServe/servePermitList";

        case 1:
          return "/hallServe/servePermitList";

        case 2:
          return "/hallServe/servePermitList";

        case 3:
          return "/personal/collection/getAllData";

        default:
          break;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.fetchList();
  },
  destroyed: function destroyed() {},
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      this.list = [];
      var sift = {};
      sift.pageNum = 1;
      sift.pageSize = 100;

      if (this.tabIndex == 0) {
        sift.recommend = 1;
      } else if (this.tabIndex == 1) {
        sift.serveSubject = 1;
      } else if (this.tabIndex == 2) {
        sift.serveSubject = 2;
      }

      if (this.tabIndex == 3) {
        this.$http.get(this.url, {
          params: sift
        }).then(function (_ref) {
          var data = _ref.data;

          if (data.resCode == 0) {
            _this.list = data.resData.list.map(function (val) {
              return {
                id: val.serveId,
                serveName: val.serveName,
                serveType: Number(val.serveType),
                serveTitle: val.serveTitle,
                appraise: val.score,
                favoriteCount: val.count,
                serveImage: val.processLogoDl,
                collection: val.serveCollect,
                interfaceUrl: val.interfaceUrl,
                linkUrl: val.interfaceUrl,
                // 新增所属部门列表字段
                deptName: val.deptNameIds ? val.deptNameIds.map(function (val) {
                  return val.deptName;
                }).join("、") : "-"
              };
            });
          }

          _this.loading = false;
        }).catch(function () {
          _this.loading = false;
        });
      } else {
        this.$http.post(this.url, this.$qs.stringify(sift)).then(function (_ref2) {
          var data = _ref2.data;

          if (data.resCode == 0) {
            _this.list = data.resData.list.map(function (val) {
              return {
                id: val.id,
                serveName: val.serveName,
                serveType: Number(val.serveType),
                serveTitle: _this.serveSubjectToString(val.serveSubjectList),
                appraise: val.commentScore,
                favoriteCount: val.storeCount,
                serveImage: val.logo,
                collection: val.serveCollect,
                interfaceUrl: val.interfaceUrl,
                linkUrl: val.linkUrl,
                // 新增所属部门列表字段
                deptName: val.deptNameIds ? val.deptNameIds.map(function (val) {
                  return val.deptName;
                }).join("、") : "-"
              };
            });
          }

          _this.loading = false;
        }).catch(function () {
          _this.loading = false;
        });
      }
    },
    serveSubjectToString: function serveSubjectToString(arr) {
      var newArr = arr.map(function (val) {
        return val.subjectName;
      });
      return newArr.join("、");
    },
    changeTabIndex: function changeTabIndex(index) {
      var _this2 = this;

      this.tabIndex = index;
      this.$nextTick(function () {
        _this2.fetchList();
      });
    }
  },
  watch: {},
  filters: {}
};